export enum BoiCollectConfigurationTypeEnum {
  applicationID = 'Application ID',
  token = 'Token'
}
